import React from 'react';
import DataTable from 'react-data-table-component';
import Loader from '../SplashScreen/loader';
import { customStyles } from './style';

const Table = ({ columns, data, loading, handlePageChange, perPage, handlePerRowsChange, total, handleSort, pagination = true }) => {
	return (
		<DataTable
			columns={columns}
			data={data}
			progressPending={loading}
			progressComponent={<Loader />}
			onChangePage={handlePageChange}
			perPage={perPage}
			onChangeRowsPerPage={handlePerRowsChange}
			paginationTotalRows={total}
			onSort={handleSort}
			customStyles={customStyles}
			pagination={pagination}
			paginationServer={pagination}
			responsive
			persistTableHead
		/>
	);
};

export default Table;

